<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showLocationAndClasstypeAndCoursepackageDialog"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="locationId"
          label="课程地点"
          align="left"
          :filters="this.courseLocationData"
          :filter-method="filterCourseLocation"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseLocation(scope.row)"
              disable-transitions
              >{{ scope.row.locationId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="classTypeId"
          label="班级类型"
          align="left"
          :filters="this.courseTypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.classTypeId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditCoursePackage(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoursePackage(scope.row, scope.$index)"
              >删除</el-button
            >
            <el-button
              type="success"
              icon="success"
              size="mini"
              @click="onAddCoursePackage(scope.row, scope.$index)"
              >课包管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="管理课包列表" :visible.sync="clockInDialogShow">
        <el-form :model="addCoursePackageForm">
          <el-form-item required prop="coursePackageIds" label="选择课包:">
            <el-cascader
              v-model="addCoursePackageForm.coursePackageIds"
              :options="options"
              :props="props"
              collapse-tags
              :show-all-levels="false"
              clearable
            ></el-cascader>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clockInDialogShow = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('addCoursePackageForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addLocationAndClasstypeAndCoursepackageDialog.show"
        :isShow="addLocationAndClasstypeAndCoursepackageDialog.show"
        :dialogRow="addLocationAndClasstypeAndCoursepackageDialog.dialogRow"
        :courseTypeList="
          addLocationAndClasstypeAndCoursepackageDialog.courseTypeList
        "
        :courseLocationList="
          addLocationAndClasstypeAndCoursepackageDialog.courseLocationList
        "
        @getLocationAndClasstype="getLocationAndClasstype"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getFormatClassTypes } from "@/api/courseType";
import { getFormatTeachingpoint } from "@/api/teachingpoint";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";
import {
  getLocationAndClasstype,
  deleteLocationAndClasstype,
  getCoursePackageIdsByLocationAndClasstypeId,
  addLocationAndClasstypeAndCoursepackage,
} from "@/api/locationAndClasstypeAndCoursepackage";
import { getFormatCoursePackagesForCourse } from "@/api/coursepackage";

export default {
  data() {
    return {
      props: { multiple: true, emitPath: false },
      options: [],
      tableData: [],
      format_schoolinfo_list: {},
      schoolInfoData: [],
      tableHeight: 0,
      loading: false,
      coursePackageIds: [],
      idFlag: false,
      clockInDialogShow: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addLocationAndClasstypeAndCoursepackageDialog: {
        show: false,
        dialogRow: {},
        courseTypeList: {},
        courseLocationList: {},
      },
      addCoursePackageForm: {
        coursePackageIds: [],
        locationClasstypeId: "",
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      courseTypeData: [],
      courseLocationData: [],
      format_course_type_list: {},
      format_course_location_list: {},
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getFormatCoursePackagesForCourse();
    this.getFormatTeachingpoint();
    this.getFormatClassTypes();
    this.getLocationAndClasstype();
  },
  methods: {
    onSubmit(form) {
      let formData = this[form];

      const para = Object.assign({}, formData);
      var coursePackageString = "";
      para.coursePackageIds.forEach((value) => {
        coursePackageString = coursePackageString + value + ",";
      });
      para.coursePackageIds = coursePackageString;
      addLocationAndClasstypeAndCoursepackage(para).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          this.$message({
            message: "新增成功",
            type: "success",
          });
          const para = {
            userName: getToken("USERNAME"),
            content: "新增地点与班级类型关系",
          };
          addOperationRecord(para).then((res) => {
            console.log(res);
          });
          this.clockInDialogShow = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          });
        }
      });
    },
    getFormatCoursePackagesForCourse() {
      getFormatCoursePackagesForCourse().then((res) => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    getFormatClassTypes() {
      getFormatClassTypes().then((res) => {
        console.log(res);
        this.courseTypeData = res.data.data.classTypeDataList;
        var courseTypeList = {
          courseTypeList: this.courseTypeData,
        };
        this.addLocationAndClasstypeAndCoursepackageDialog.courseTypeList = courseTypeList;
        this.format_course_type_list = res.data.data.formatClassTypeList;
      });
    },
    getFormatTeachingpoint() {
      getFormatTeachingpoint().then((res) => {
        this.courseLocationData = res.data.data.courseLocationData;

        var courseLocationList = {
          courseLocationList: this.courseLocationData,
        };
        this.addLocationAndClasstypeAndCoursepackageDialog.courseLocationList = courseLocationList;
        this.format_course_location_list =
          res.data.data.formatCourseLocationList;
      });
    },
    /**
     * 格式化状态
     */
    filterCourseType(value, item) {
      console.log(item.classTypeId);
      const type = parseInt(item.classType);
      return (
        this.format_course_type_list[value] ==
        this.format_course_type_list[type]
      );
    },
    filterCourseLocation(value, item) {
      const type = parseInt(item.locationId);
      return (
        this.format_course_location_list[value] ==
        this.format_course_location_list[type]
      );
    },
    formatterCourseType(item) {
      const type = parseInt(item.classTypeId);
      return this.format_course_type_list[type];
    },
    formatterCourseLocation(item) {
      const type = parseInt(item.locationId);
      return this.format_course_location_list[type];
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getLocationAndClasstype() {
      const para = this.courseData;
      getLocationAndClasstype(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.locationAndClasstypes;
      });
    },
    // 显示添加预约类型弹窗
    showLocationAndClasstypeAndCoursepackageDialog(val) {
      this.$store.commit("SET_LOCATION_CLASSTYPE_DIALOG_TITLE", val);
      this.addLocationAndClasstypeAndCoursepackageDialog.show = true;
    },
    hideAddFundDialog() {
      this.addLocationAndClasstypeAndCoursepackageDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getLocationAndClasstype();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getLocationAndClasstype();
    },
    // 编辑操作方法
    onEditCoursePackage(row) {
      var param = Object.assign({}, row);
      this.addLocationAndClasstypeAndCoursepackageDialog.dialogRow = {
        param,
      };
      this.showLocationAndClasstypeAndCoursepackageDialog();
    },
    onAddCoursePackage(row) {
      this.clockInDialogShow = true;
      this.addCoursePackageForm.locationClasstypeId = row.id;
      this.addCoursePackageForm.coursePackageIds = [];
      console.log(row.id);
      getCoursePackageIdsByLocationAndClasstypeId({
        locationAndClasstypeId: row.id,
      }).then((res) => {
        console.log(res);
        if (res.data.data == null) {
          this.addCoursePackageForm.coursePackageIds = [];
        } else {
          this.addCoursePackageForm.coursePackageIds = res.data.data.split(",");
        }
      });
    },
    // 删除数据
    onDeleteCoursePackage(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteLocationAndClasstype(row.id).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除地点与班级类型关系",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            // const para = {
            //   userName: getToken("USERNAME"),
            //   content: "删除(" + row.packageName + ")课包类型操作",
            // };
            // addOperationRecord(para).then((res) => {
            //   console.log(res);
            // });
            // this.getLocationAndClasstype();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


